/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { CannedCollectionModule } from '@coursera-web/cds-labs';
import type { CannedCollectionModuleCard } from '@coursera-web/cds-labs';

import { breakpoints, useMediaQuery } from '@coursera/cds-core';
import { useTracker } from '@coursera/event-pulse/react';

import { getUpsellCards } from 'bundles/browse-common/utils/experimentUtils';
import CannedCollectionsSchemaMarkup from 'bundles/seo/components/CannedCollectionsSchemaMarkup';

const UpsellCardModuleRenderer = () => {
  const track = useTracker();
  const isMobile = useMediaQuery(breakpoints.down('sm'));

  const upsellCards = getUpsellCards();

  const clickHandler = (card: (typeof upsellCards)[number]) => {
    track('click_upsell_card', {
      upsellType: card.id,
    });
  };

  const itemCards: CannedCollectionModuleCard[] = upsellCards.map((card) => {
    const { headline, body, target, ctaText, cardBackgroundImage, backgroundColor, eyebrowImage } = card;
    const onClick = () => {
      clickHandler(card);
    };

    return {
      id: card.id,
      headline,
      body,
      target,
      ctaText,
      cardBackgroundImage: !isMobile ? cardBackgroundImage : undefined,
      backgroundColor: backgroundColor,
      eyebrowImage,
      onClick,
    };
  });

  const heading = undefined;
  const subheading = undefined;
  const size = isMobile ? 'small' : 'large';
  const color = 'dark-blue';
  const preloadImage = false;
  const lazyLoadImage = true;
  const showAllEntries = false;

  return (
    <>
      <CannedCollectionModule
        heading={heading}
        subheading={subheading}
        cards={itemCards}
        size={size}
        color={color}
        preloadImage={!!preloadImage}
        lazyLoadImage={!!lazyLoadImage}
        showAllEntries={!!showAllEntries}
        backgroundColor="white"
        removeTopPadding={false}
        removeBottomPadding={false}
      />
      <CannedCollectionsSchemaMarkup cards={itemCards} headline={heading} description={subheading} />
    </>
  );
};

export default UpsellCardModuleRenderer;
